<template>

  <!--Gallery Page Start-->
  <section class="gallery-page">
            <div class="container">
                <div class="row">
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/grua4.jpg" alt="">
                                <a href="assets/images/homeGallery/grua4-2.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Extraccion de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/grua2.jpg" alt="">
                                <a href="assets/images/homeGallery/grua2-2.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Instalación de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/maquina.jpg" alt="">
                                <a href="assets/images/homeGallery/maquina.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Creación y diseño de tableros eléctricos</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/grua1.jpg" alt="">
                                <a href="assets/images/homeGallery/grua1-2.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Extracción de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/trabajos1.jpeg" alt="">
                                <a href="assets/images/homeGallery/trabajos1-1.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Instalación de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                                                        
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/trabajos2.jpeg" alt="">
                                <a href="assets/images/homeGallery/trabajos2-2.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Extracción de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/trabajos3.jpeg" alt="">
                                <a href="assets/images/homeGallery/trabajos3-3.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Extracción de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/fusibles1-1.jpeg" alt="">
                                <a href="assets/images/homeGallery/fusibles1.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Diseño e instalación de tableros de fuerza y control</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/camion4.jpeg" alt="">
                                <a href="assets/images/homeGallery/camion4-4.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/camion3.jpeg" alt="">
                                <a href="assets/images/homeGallery/camion3-3.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/camion-2.jpeg" alt="">
                                <a href="assets/images/homeGallery/camion.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Movimiento con camión pluma</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/movimiento1-1.jpeg" alt="">
                                <a href="assets/images/homeGallery/movimiento1.jpeg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Instalación de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/maquina2.jpg" alt="">
                                <a href="assets/images/homeGallery/maquina2.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Instalación de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/grua3.jpg" alt="">
                                <a href="assets/images/homeGallery/grua3-2.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Extracción de bomba de pozo profundo</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/grua5.png" alt="">
                                <a href="assets/images/homeGallery/grua5-2.png" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Creación de piping</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/panel.jpg" alt="">
                                <a href="assets/images/homeGallery/panel.jpg" class="img-popup"></a>
                                <!-- /.img-popup -->
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Equipo</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Instalación de equipo de bombeo solar</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/rose1.jpeg" alt="">
                                <a href="assets/images/homeGallery/rose.JPEG" class="img-popup"></a>
                                
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/uva.JPEG" alt="">
                                <a href="assets/images/homeGallery/uva.JPEG" class="img-popup"></a>
                                 
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <!--Gallery Page Single Start-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/ieh.JPG" alt="">
                                <a href="assets/images/homeGallery/ieh.JPG" class="img-popup"></a>
                                 
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Instalación de telemetría</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeGallery/palma.JPEG" alt="">
                                <a href="assets/images/homeGallery/palma.JPEG" class="img-popup"></a>
                                 
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Gallery Page Single End-->
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeFotos/IMG_3518.jpeg" alt="">
                                <a href="assets/images/homeFotos/IMG_3518.jpeg" class="img-popup"></a>
                                 
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeFotos/IMG_3528.jpeg" alt="">
                                <a href="assets/images/homeFotos/IMG_3528.jpeg" class="img-popup"></a>
                                 
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-6 col-md-6">
                        <div class="gallery-page__single">
                            <div class="gallery-page__img">
                                <img src="assets/images/homeFotos/IMG_5209.jpeg" alt="">
                                <a href="assets/images/homeFotos/IMG_5209.jpeg" class="img-popup"></a>
                                 
                                <div class="gallery-page__content">
                                    <!-- <p class="gallery-page__sub-title">Charity</p> -->
                                    <h5 class="gallery-page__title"><a href="gallery.html">Imágenes</a></h5>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section>
        <!--Gallery Page End-->
  
</template>

<script>
    export default {
        mounted(){
            this.thmSwiperInit();
        },
        methods:{
            thmSwiperInit() {
                if ($(".img-popup").length) {
                    var groups = {};
                    $(".img-popup").each(function () {
                    var id = parseInt($(this).attr("data-group"), 10);

                    if (!groups[id]) {
                        groups[id] = [];
                    }

                    groups[id].push(this);
                    });

                    $.each(groups, function () {
                    $(this).magnificPopup({
                        type: "image",
                        closeOnContentClick: true,
                        closeBtnInside: false,
                        gallery: {
                        enabled: true
                        }
                    });
                    });
                }
            }
        }
    }
</script>